import { useIsAppNavOpenedValue, useSetOpenedPopupsState } from '@/atoms/opened-popups';
import classNames from 'classnames';
import Link from '@/components/shared/Link';
import Nav from '../Nav';
import { YD_NEW_ID } from '@/metrics/ym';
import Button from '@/components/shared/Button';
import SearchSVGWhite from '@/svg/search-white.svg?url';
import { useFiltersVisibleState } from '@/atoms/search-popup-visible';
import { SMALL_SEARCH_POPUP_NAME } from '@/components/layout/CatalogFilters/SmallSearchPopup';
import PhoneSVGWhite from '@/svg/phone-white.svg?url';
import LogoRotormine from '@/svg/logo-rotormine.svg?url';
import { PHONE_BUTTON_POPUP_NAME } from '@/components/general/PhoneButton/PhoneButton';

const Header = () => {
    const isAppNavPopupOpened = useIsAppNavOpenedValue();
    const setFiltersVisible = useFiltersVisibleState();
    const { openPopup } = useSetOpenedPopupsState();

    return (
        <header
            className={classNames('header', {
                'burger-opened': isAppNavPopupOpened,
            })}
        >
            <div className="header-inner wrapper">
                <button
                    className="header__phone"
                    onClick={() => {
                        openPopup(PHONE_BUTTON_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_phone');
                    }}
                    aria-label="Форма обратной связи"
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img src={PhoneSVGWhite} alt="" width={16} height={16} className="img-fluid" decoding="async" />
                </button>
                <div className="header-logos-wrapper">
                    <Link href="/" className={classNames('header-logo')} aria-label="Rotormine">
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img
                            src={LogoRotormine}
                            alt="Rotormine"
                            width={114}
                            height={48}
                            className="img-fluid"
                            decoding="async"
                        />
                        <div className="logo-shine"></div>
                    </Link>
                </div>
                <Nav />
            </div>
            <div className="wrapper">
                <Button
                    className="catalog-filter-btn catalog-filter-btn--search catalog-filter-btn--header"
                    icon={
                        // eslint-disable-next-line @next/next/no-img-element
                        <img src={SearchSVGWhite} alt="" width={20} height={20} className="img-fluid" />
                    }
                    size="sm"
                    onClick={() => {
                        setFiltersVisible(false);
                        openPopup(SMALL_SEARCH_POPUP_NAME);
                    }}
                >
                    Поиск товара
                </Button>
            </div>
        </header>
    );
};

export default Header;
